import classNames from "components/ui/classNames";
import type { ReactNode } from "react";

interface IPageHeadingProps {
  icon: ReactNode;
  iconContainerClassName?: string;
  title: ReactNode;
  description: ReactNode;
}

export default function PageHeading({ icon, iconContainerClassName, title, description }: IPageHeadingProps) {
  return (
    <header className="my-8 flex flex-col items-center space-y-4 text-center font-aeonik md:flex-row md:space-x-4 md:space-y-0 md:text-left">
      <div className="rounded-full border border-gray-200 bg-white p-1 dark:bg-transparent dark:border-transparent">
        <div
          className={classNames(
            iconContainerClassName,
            "inline-flex rounded-full border p-4 dark:bg-opacity-5 dark:border-transparent dark:squircle",
          )}
        >
          {icon}
        </div>
      </div>

      <div className="space-y-2 md:space-y-1 lg:space-y-0">
        <h1 className="m-0 text-3xl font-bold text-gray-600 dark:text-gray-200 lg:text-2xl">{title}</h1>
        <h6 className="m-0 text-base font-normal leading-6 tracking-wide text-gray-500 dark:text-gray-400 md:text-base">
          {description}
        </h6>
      </div>
    </header>
  );
}
